import type { IStringTool } from "../core/IStringTool.ts"
import type { StringVector } from "../models/vector/StringVector.ts"

/**
 * Input parameters for LerpVector2Tool.
 */
interface LerpVector2Input {
  /**
   * Starting vector value `{ x, y }`.
   */
  from: StringVector

  /**
   * Target vector value `{ x, y }`.
   */
  to: StringVector

  /**
   * Interpolation progress from `0` (start) to `1` (end).
   */
  progress: number
}

/**
 * Tool for linearly interpolating between two 2D vectors.
 * Useful for cursor smoothing, UI element animations, and motion blending.
 */
export default class LerpVector2Tool implements IStringTool<LerpVector2Input, StringVector> {
  /**
   * Calculates the interpolated vector between `from` and `to`.
   *
   * @param input.from - The starting vector `{ x, y }`.
   * @param input.to - The target vector `{ x, y }`.
   * @param input.progress - Interpolation progress from `0` (start) to `1` (end).
   * @returns Interpolated vector `{ x, y }`.
   */
  process({ from, to, progress }: LerpVector2Input): { x: number, y: number } {
    return {
      x: (to.x - from.x) * progress,
      y: (to.y - from.y) * progress,
    }
  }
}

